export class Product {
	id!: string;
	label!: string;
	company?: Publisher;
	productFilters!: ProductCustomFilter[];
}

export class ProductCustomFilter {
	categoryId!: number;
	categoryType: number = 0;
	categoryLabel!: string;
	categorySortNumber!: number;
	valueLabel!: string;
	valueSortNumber!: number;
}

export class Publisher {
	id!: string;
	label!: string;
}